<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <b-button
          variant="primary"
          class="btn btn-primary float-right mb-1"
          @click="doImport"
          :disabled="importing">
          <i class="icon-cloud-download" v-if="!importing" />
          <b-spinner v-if="importing" class="mr-1" type="border" small />
          &nbsp;{{ importing ? "Importerar" : "Importera" }}
        </b-button>
      </div>
    </div>
    <b-card>
      <div slot="header">Import</div>
      <table class="table table-striped table-hover d-none d-md-block">
        <thead>
          <tr>
            <th class="col-7">Namn</th>
            <th class="col-1 text-center">Skapade</th>
            <th class="col-1 text-center">Uppdaterade</th>
            <th class="col-1 text-center">Oförändrade</th>
            <th class="col-1 text-center">Raderade</th>
            <th class="col-1 text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="imp in imports" :key="imp.id" style="cursor:pointer">
            <td class="col-7">{{imp.name}}</td>
            <td class="col-1 text-center">{{imp.added}}</td>
            <td class="col-1 text-center">{{imp.updated}}</td>
            <td class="col-1 text-center">{{imp.unchanged}}</td>
            <td class="col-1 text-center">{{imp.deleted}}</td>
            <td class="col-1 text-center">
                <i class="icon-question icons font-weight-bold" v-if="!imp.imported && !imp.error && !imp.importing" />
                <i class="icon-check icons text-success font-weight-bold" v-if="imp.imported && !imp.error && !imp.importing" />
                <i class="icon-exclamation icons text-danger font-weight-bold" v-if="imp.error && !imp.importing" />
                <b-spinner v-if="imp.importing" class="mr-1" type="border" small /></td>
          </tr>
        </tbody>
      </table>
      <table class="table table-striped table-hover d-block d-md-none">
        <thead>
          <tr>
            <th class="col-11">Namn</th>
            <th class="col-1 text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="imp in imports" :key="imp.id" style="cursor:pointer">
            <td class="col-11">{{imp.name}}</td>
            <td class="col-1 text-center">
                <i class="icon-question icons font-weight-bold" v-if="!imp.imported && !imp.error && !imp.importing" />
                <i class="icon-check icons text-success font-weight-bold" v-if="imp.imported && !imp.error && !imp.importing" />
                <i class="icon-exclamation icons text-danger font-weight-bold" v-if="imp.error && !imp.importing" />
                <b-spinner v-if="imp.importing" class="mr-1" type="border" small /></td>
          </tr>
        </tbody>
      </table>
    </b-card>
  </div>
</template>

<script>
async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

import { importService } from "../../shared/services";
export default {
  data: function() {
    return {
      importing: false,
      imports: [
        {
          id: 0,
          name: "Kunder", added: null, updated: null, unchanged: null, deleted: null, importing: false, imported: false, error: false,
          import: async function(clientId) {
            return await importService.importClients(clientId);
          }
        }, {
          id: 1,
          name: "Projekt", added: null, updated: null, unchanged: null, deleted: null, importing: false, imported: false, error: false,
          import: async function(clientId) {
            return await importService.importProjects(clientId);
          }
        }, {
          id: 2,
          name: "Projektkategorier", added: null, updated: null, unchanged: null, deleted: null, importing: false, imported: false, error: false,
          import: async function(clientId) {
            return await importService.importProjectCategories(clientId);
          }
        }, {
          id: 3,
          name: "Utgiftskategorier", added: null, updated: null, unchanged: null, deleted: null, importing: false, imported: false, error: false,
          import: async function(clientId) {
            return await importService.importExpenseCategories(clientId);
          }
        }, {
          id: 4,
          name: "Utgifter", added: null, updated: null, unchanged: null, deleted: null, importing: false, imported: false, error: false,
          import: async function(clientId) {
            return await importService.importExpenses(clientId);
          }
        }, {
          id: 5,
          name: "Tidrapporteringar", added: null, updated: null, unchanged: null, deleted: null, importing: false, imported: false, error: false,
          import: async function(clientId) {
            return await importService.importTimeEntries(clientId);
          }
        },
      ]
    };
  },
  methods: {
    async doImport() {
      this.importing = true;

      for (let index = 0; index < this.imports.length; index++) {
        let i = this.imports[index];
        i.added = null;
        i.updated = null;
        i.deleted = null;
        i.error = null;
        i.unchanged = null;
      }

      for (let index = 0; index < this.imports.length; index++) {
        let i = this.imports[index];
        i.importing = true;
        try {
          var result = await i.import(this.loginState.user.companyId);
          i.added = result.added;
          i.updated = result.updated;
          i.unchanged = result.unchanged;
          i.deleted = result.deleted;
          i.imported = true;
        } catch {
          i.error = true;
          this.ShowToast(
                "Fel",
                `Ett okänt fel uppstod då data för '${i.name}' skulle importeras`,
                "danger"
              );
        } finally {
          i.importing = false;
        }
      }

      this.importing = false;
    }
  },
  async mounted() {

  }
};
</script>

<style></style>
